export const BILLING_ACCOUNT_RECON_TAG_NAME = 'tm-bo-billing-account-recon';
export const BILLING_ACH_CONTAINER_TAG_NAME = 'tm-bo-company-billing-ach-container';
export const BILLING_POS_PAY_CONTAINER_TAG_NAME = 'tm-bo-company-billing-pos-pay-container';
export const BILLING_STP_PAY_CONTAINER_TAG_NAME = 'tm-bo-company-billing-stp-pay-container';
export const BILLING_TRANSFER_CONTAINER_TAG_NAME = 'tm-bo-company-billing-transfer-container';
export const BILLING_WIRES_TAG_NAME = 'tm-bo-company-billing-wires-container';
export const BILLING_DETAILS_TAG_NAME = 'tm-bo-billing-details';
